import * as React from 'react';
import api from "../utils/api_v2";
import LodingData from "../utils/LodingData";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Loginbg from '../assets/images/login_bg.png';
import logo from '../assets/images/logo.png';
import { useRef } from "react";
import { CircularProgress, Typography } from '@mui/material';
import styles from "../styles/common/Login.module.css";


const Login = () => {
  const navigate = useNavigate();
  const [customerId, setCustomerId] = React.useState('');
  const [customerPw, setCustomerPw] = React.useState('');

  function login() {
    LodingData(() => api.post('permission/login', { level: 'CUSTOMER', id: customerId, password: customerPw }).then(res => {
      if (res.data.message == "FAILED") {
        alert("가입하지 않은 아이디이거나, 잘못된 비밀번호입니다.");
      } else {
        var split = res.data.message.split('/');
        localStorage.setItem("token", res.data.data);
        localStorage.setItem("userID", split[5]);
        localStorage.setItem("userName", split[0]);
        localStorage.setItem("userCusID", split[1]);
        localStorage.setItem("stressSurvey", split[2]);
        localStorage.setItem("ownerFamID", split[3]);
        localStorage.setItem("hraSurvey", split[4]);
        
        api.get('customer/api/v2/families/' + encodeURIComponent(split[3]) + '/companies').then((res: any) => {
          const companyId = res.data.data.company_id;
          localStorage.setItem("companyId", companyId);
        }).catch(function (error: any) {
          console.log(error)
        });
        
        navigate('/');
      }
    }).catch(function (error) {
      console.log(error);
    }));
  }

  function logout() {
    localStorage.clear();
    alert("로그아웃 되었습니다.");
  }

  // input 엔터 시
  const handleActiveEnter = (e: any) => {
    if (e.key == 'Enter') {
      login();
    }
  }

  const loginField = {
    width: '350px',
    marginBottom: '10px',

    '& label': {
      color: '#aaa',
    },
    '& label.Mui-focused': {
      color: '#087200',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#087200',
    },
    '& .MuiInputBase-root:before': {
      borderBottomColor: '#bbb',
    }
  };

  const Logbg = {
    width: '1450px',
    height: '100vh',
    backgroundImage: `url(${Loginbg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  }

  const loadingContainer = {
    display: 'none',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(241, 242, 243, 0.5)',
    zIndex: 9999,
  }

  const LoadingComponent = () => {
    return (
      <Box
        sx={loadingContainer}
        id="loadingBox"
      >
        <Typography sx={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'black' }}>
          잠시만 기다려주세요.
        </Typography>
        <CircularProgress color="secondary" />
      </Box>
    )
  }

  return (
    <Container sx={{ padding: '0px!important', maxWidth: '100%!important' }} className={styles.chatnone}>
      <Stack flexDirection={'row'} alignItems={'center'}>
        <Box sx={Logbg}></Box>
        <Stack sx={{ width: '500px', height: '100vh', border: '1px solid #ccc', boxSizing: 'border-box', pt: 15 }} alignItems={'center'} >
          <img src={logo} style={{ marginBottom: 30 }}></img>

          <Typography sx={{ fontSize: 30, fontWeight: 'bold', pt: 8, pb: 5, color: '#333' }}>CUSTOMER</Typography>
          <TextField label="ID" variant="standard"
            onChange={(e) => { setCustomerId(e.target.value) }} sx={loginField}
            onKeyDown={handleActiveEnter}
          />
          <TextField label="Password" variant="standard"
            type={'password'}
            onChange={(e) => { setCustomerPw(e.target.value) }} sx={loginField}
            onKeyDown={handleActiveEnter}
          />

          <Button variant="contained" onClick={login} sx={BottomBtnStyle}>Login</Button>

          <Stack direction={'row'} justifyContent={'center'} sx={{ mt: 3 }}>
            <Button onClick={() => navigate('../Join/JoinAgree')} sx={{ fontSize: 12, color: '#444' }}>회원가입</Button>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Button onClick={() => navigate('../Join/FindId')} sx={{ fontSize: 12, color: '#444' }}>아이디 찾기</Button>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Button onClick={() => navigate('../Join/FindPassword')} sx={{ fontSize: 12, color: '#444' }}>비밀번호 찾기</Button>
          </Stack>
        </Stack>
      </Stack>

      {
        LoadingComponent()
      }
    </Container>
  );
}


const BottomBtnStyle = {
  width: '350px',
  bgcolor: '#087200',
  fontSize: 18,
  fontWeight: 700,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #087200',
  mt: 4,
  mb: 1,
  ':hover': {
    backgroundColor: '#065300',
    borderColor: '#065300',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#087200',
    borderColor: '#087200',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default Login;